import { useEditor } from '@craftjs/core';
import { SliderField } from '../SliderField/SliderField';
import type { FormProps } from '@builder4/shared/components/Form';
import { useInspectorNode } from '@/hooks/useInspectorNode';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { FORM_NODE_NAME } from '@/utils/constants';

const NodeFieldTextSpacing = () => {
  const { actions } = useEditor();
  const { id, props: nodeProps, node } = useInspectorNode<Partial<FormProps>>();

  const { getBPProp, setBPProp } = useBreakpointAwareProp(node?.data.displayName || FORM_NODE_NAME);

  // Read props using breakpoint-aware getter
  const fieldInputSpacing = getBPProp(nodeProps, 'fieldInputSpacing');

  const handleChange = (value: number) => {
    actions.history.ignore().setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldInputSpacing', value, FORM_NODE_NAME);
    });
  };

  const handleChangeComplete = (value: number, initialValue: number) => {
    actions.history.ignore().setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldInputSpacing', initialValue, FORM_NODE_NAME);
    });
    actions.setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldInputSpacing', value, FORM_NODE_NAME);
    });
  };

  return (
    <SliderField
      label="Spacing"
      value={fieldInputSpacing || 0}
      onChange={handleChange}
      onChangeComplete={handleChangeComplete}
      min={0}
      max={40}
    />
  );
};

export default NodeFieldTextSpacing;
